module.exports = __webpack_public_path__ + "static/media/logo-symbol-green.41c6a2a6.svg";